module.exports = __webpack_public_path__ + "static/img/home2.abf3a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/home2.jpg
// module id = ddg9
// module chunks = 1